module.exports = __webpack_public_path__ + "assets/1fd1bc6ca9d2f9a0ff7635d71163fc05.png";